/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_History_TitleInputs */

const vi_trip_history_title = /** @type {(inputs: Trip_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyến giao`)
};

/**

* @param {Trip_History_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_history_title = /** @type {((inputs?: Trip_History_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_History_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_history_title(inputs)
});